__webpack_require__.p = "https://frontends.udemycdn.com/frontends-ob-assertion-detail/_next/";